import React from "react";
import { iconProps } from "../../../Helper";

export const ParaphraseIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_8637_86026"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8637_86026)">
        <path
          className={className}
          d="M3.3335 12.6668H4.1745L10.9988 5.8425L10.1578 5.0015L3.3335 11.8258V12.6668ZM2.3335 13.6668V11.4105L11.1272 2.62066C11.2279 2.52911 11.3392 2.45838 11.461 2.4085C11.5829 2.3585 11.7107 2.3335 11.8443 2.3335C11.978 2.3335 12.1074 2.35722 12.2327 2.40466C12.358 2.45211 12.4689 2.52755 12.5655 2.631L13.3797 3.45533C13.4831 3.55188 13.5568 3.663 13.6008 3.78866C13.6448 3.91433 13.6668 4.04 13.6668 4.16566C13.6668 4.29977 13.6439 4.42772 13.5982 4.5495C13.5524 4.67139 13.4796 4.78272 13.3797 4.8835L4.58983 13.6668H2.3335ZM10.571 5.42933L10.1578 5.0015L10.9988 5.8425L10.571 5.42933Z"
          fill="white"
        />
        <path
          className={className}
          d="M3.66667 1L4.43977 2.89356L6.33333 3.66667L4.43977 4.43977L3.66667 6.33333L2.89356 4.43977L1 3.66667L2.89356 2.89356L3.66667 1Z"
          fill="white"
        />
        <path
          className={className}
          d="M12.3332 10.3279L12.8748 11.6546L12.9145 11.7518L13.0118 11.7915L14.3384 12.3332L13.0118 12.8748L12.9145 12.9145L12.8748 13.0118L12.3332 14.3384L11.7915 13.0118L11.7518 12.9145L11.6546 12.8748L10.3279 12.3332L11.6546 11.7915L11.7518 11.7518L11.7915 11.6546L12.3332 10.3279Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
